import { render, staticRenderFns } from "./ParciaisValorizacao.vue?vue&type=template&id=24a17a6c&scoped=true"
import script from "./ParciaisValorizacao.vue?vue&type=script&lang=js"
export * from "./ParciaisValorizacao.vue?vue&type=script&lang=js"
import style0 from "./ParciaisValorizacao.vue?vue&type=style&index=0&id=24a17a6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a17a6c",
  null
  
)

export default component.exports